import React from 'react'
import uuidv4 from 'uuid/v4'
import { clone } from 'lodash'
import Snackbar from 'material-ui-legacy/Snackbar'

import {
  ServiceCategoryHeader,
  ServiceCategorySubtotal
} from './QuoteFormComponents'
import ActualLineItemInput from './ActualLineItemInput'
import './styles/line-items-container.css'

import Resource from '../../stores/resource'
const ActualLineItemStore = Resource('actual-line-items')

/*
This component is used inside ActualForm.
Props:
- category: a ServiceCategory instance.
- actualId: the actual object id
- actualLineItems: array of actualLineItems. These will be filtered by the given ServiceCategory.
             Note that it's expected these line items already contain a key, since
             they will come from ActualForm.
- batchOnChange: callback function, returns all contained actualLineItems on change
                 function(actualLineItems, categoryId)
*/
class CategoryActualLineItemsContainer extends React.PureComponent {
  constructor(props) {
    super(props)
    const { actualLineItems, category } = this.props

    let initialState = {
      actualLineItems: [],
      total: 0.0
    }

    const initialActualLineItems = actualLineItems.filter(actualLineItem => {
      const li = actualLineItem.attributes
      return Number(li.serviceCategoryId) === Number(category.id)
    })

    if (initialActualLineItems.length > 0) {
      // Always sort by service order
      initialState.actualLineItems = initialActualLineItems.sort(
        (a, b) => a.order - b.order
      )
      initialState.total = this._calculateTotal(initialState.actualLineItems)
    }

    this.state = clone(initialState)
  }

  _calculateTotal = (actualLineItems = this.state.actualLineItems) => {
    let total = 0.0
    for (let actualLineItem of actualLineItems) {
      let attributes = actualLineItem.attributes
      total += Number(attributes.actualTotal)
    }
    return total
  }

  _findByKey = (key, lineItems = this.state.actualLineItems) =>
    lineItems.find(lineItem => lineItem.key === key)

  _deleteActualLineItem = key => {
    let actualLineItems = this.state.actualLineItems.filter(
      actualLineItem => actualLineItem.key !== key
    )
    this._updateActualLineItems(actualLineItems)
  }

  _addActualLineItem = (serviceId, service) => {
    let newActualLineItem = ActualLineItemStore.makeEntity({
      actualId: this.props.actualId || null,
      serviceId: serviceId,
      event: '',
      description: '',
      actualNumber: 1,
      actualCost: service.attributes.cost,
      actualRate: service.attributes.rate,
      rateUnit: service.attributes.rateUnit,
      actualAdjustment: 0.0,
      actualTotal: service.attributes.rate,
      hideClientRates: false,
      cloned: false
    })
    // We absolutely must have a unique id or key
    newActualLineItem.key = uuidv4()
    // We're adding the selected service instance too
    newActualLineItem.service = service
    let actualLineItems = clone(this.state.actualLineItems)
    actualLineItems.push(newActualLineItem)
    this._updateActualLineItems(actualLineItems)
  }

  // Updates actualLineItems and totals at the same time
  _updateActualLineItems = (actualLineItems = this.state.actualLineItems) => {
    const { batchOnChange, category } = this.props
    const total = this._calculateTotal(actualLineItems)
    this.setState(
      {
        actualLineItems: actualLineItems,
        total: total
      },
      () => {
        if (batchOnChange) {
          batchOnChange(actualLineItems, category.id)
        }
      }
    )
  }

  _handleActualLineItemChange = (attributes, key) => {
    const { actualLineItems } = this.state
    const actualLineItemIndex = actualLineItems.findIndex(
      actualLineItem => actualLineItem.key === key
    )
    if (actualLineItemIndex < 0) return
    let newActualLineItems = clone(actualLineItems)
    newActualLineItems[actualLineItemIndex].attributes = attributes
    this._updateActualLineItems(newActualLineItems)
  }

  _resetSnackbar = () => this.setState({ error: '' })

  render() {
    const { category, actualId, originalLineItems } = this.props
    const { actualLineItems, total, error } = this.state

    return (
      <section className="line-items-container">
        <ServiceCategoryHeader
          category={category}
          onSelected={this._addActualLineItem}
        />
        {actualLineItems.map((actualLineItem, index) => (
          <ActualLineItemInput
            key={actualLineItem.key}
            originalLineItem={this._findByKey(
              actualLineItem.key,
              originalLineItems
            )}
            actualLineItem={actualLineItem}
            service={actualLineItem.service}
            actualId={actualId}
            deleteCallback={() =>
              this._deleteActualLineItem(actualLineItem.key)
            }
            validatedOnChange={attributes =>
              this._handleActualLineItemChange(attributes, actualLineItem.key)
            }
          />
        ))}

        {actualLineItems.length > 0 && (
          <ServiceCategorySubtotal total={total} />
        )}

        <Snackbar
          open={Boolean(error)}
          message={`Coulnd't get line item service: ${error}`}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />
      </section>
    )
  }
}

export default CategoryActualLineItemsContainer



// WEBPACK FOOTER //
// ./src/components/Quotes/CategoryActualLineItemsContainer.jsx